// Action types
const SET_FORGOT_PASSWORD_EMAIL = "forgotPassword/SET_EMAIL";
const SET_FORGOT_PASSWORD_ACCESS_TOKEN = "forgotPassword/SET_ACCESS_TOKEN";
const RESET_FORGOT_PASSWORD = "forgotPassword/RESET";
const SET_PASSWORD_CHANGED = "forgotPassword/SET_PASSWORD_CHANGED";

// Utility to load from session storage
const loadStateFromSession = () => {
  try {
    const serializedState = sessionStorage.getItem("forgotPassword");
    return serializedState ? JSON.parse(serializedState) : undefined;
  } catch (e) {
    console.error("Failed to load from sessionStorage", e);
    return undefined;
  }
};

const saveStateToSession = (state) => {
  try {
    sessionStorage.setItem("forgotPassword", JSON.stringify(state));
  } catch (e) {
    console.error("Failed to save to sessionStorage", e);
  }
};

const clearStateFromSession = () => {
  try {
    sessionStorage.removeItem("forgotPassword");
  } catch (e) {
    console.error("Failed to clear sessionStorage", e);
  }
};

// Default state
const defaultState = {
  email: "",
  accessToken: "",
  isPassChanged: false, // transient, not stored in session
};

// Hydrated initial state
const sessionState = loadStateFromSession();
const initialState = {
  ...defaultState,
  ...(sessionState || {}),
};

// Reducer
export default function forgotPasswordReducer(state = initialState, action) {
  let nextState;

  switch (action.type) {
    case SET_FORGOT_PASSWORD_EMAIL:
      nextState = { ...state, email: action.payload };
      saveStateToSession({
        email: nextState.email,
        accessToken: nextState.accessToken,
      });
      return nextState;

    case SET_FORGOT_PASSWORD_ACCESS_TOKEN:
      nextState = { ...state, accessToken: action.payload };
      saveStateToSession({
        email: nextState.email,
        accessToken: nextState.accessToken,
      });
      return nextState;

    case SET_PASSWORD_CHANGED:
      return { ...state, isPassChanged: action.payload };

    case RESET_FORGOT_PASSWORD:
      clearStateFromSession();
      return { ...defaultState, isPassChanged: true };

    default:
      return state;
  }
}

// Action creators
export const setForgotPasswordEmail = (email) => ({
  type: SET_FORGOT_PASSWORD_EMAIL,
  payload: email,
});

export const setForgotPasswordAccessToken = (token) => ({
  type: SET_FORGOT_PASSWORD_ACCESS_TOKEN,
  payload: token,
});

export const resetForgotPassword = () => ({
  type: RESET_FORGOT_PASSWORD,
});

export const setPasswordChanged = (isChanged) => ({
  type: SET_PASSWORD_CHANGED,
  payload: isChanged,
});
